import React, { createContext, useContext, useEffect, useState } from 'react';
import io from 'socket.io-client';

const SocketContext = createContext();

// let serverUrl = 'http://locaclhost:3001'; // Default server URL
let serverUrl = 'https://webrtc-server.sitras.id'; // Default server URL
export const useSocket = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error('useSocket must be used within a SocketProvider');
  }
  return context;
};

export const SocketProvider = ({ children, userId, role, roomId }) => {
  const [socket, setSocket] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const [roomState, setRoomState] = useState({
    students: [],
    supervisors: []
  });
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    // Initialize socket connection
    const newSocket = io(serverUrl, {
      transports: ['websocket']
    });
//     const newSocket = io('https://3.25.216.38', {
//   path: '/webrtc-server/socket.io',
//   transports: ['websocket']
// });

    newSocket.on('connect', () => {
      console.log('Connected to server:', newSocket.id);
      setIsConnected(true);
      
      // Join room immediately after connection
      newSocket.emit('join-room', {
        userId,
        role,
        roomId
      });
    });

    newSocket.on('disconnect', () => {
      console.log('Disconnected from server');
      setIsConnected(false);
    });

    // Room state updates
    newSocket.on('room-state', (state) => {
      console.log('Room state updated:', state);
      setRoomState(state);
    });

    newSocket.on('user-joined', (user) => {
      console.log('User joined:', user);
      setRoomState(prev => {
        const newState = { ...prev };
        if (user.role === 'student') {
          newState.students = [...prev.students.filter(s => s.userId !== user.userId), {
            userId: user.userId,
            socketId: user.socketId,
            audioMuted: false,
            isActive: true,
            lastSeen: Date.now()
          }];
        } else if (user.role === 'supervisor') {
          newState.supervisors = [...prev.supervisors.filter(s => s.userId !== user.userId), {
            userId: user.userId,
            socketId: user.socketId
          }];
        }
        return newState;
      });
    });

    newSocket.on('user-left', (user) => {
      console.log('User left:', user);
      setRoomState(prev => {
        const newState = { ...prev };
        if (user.role === 'student') {
          newState.students = prev.students.filter(s => s.userId !== user.userId);
        } else if (user.role === 'supervisor') {
          newState.supervisors = prev.supervisors.filter(s => s.userId !== user.userId);
        }
        return newState;
      });
    });

    // Alert handling
    newSocket.on('alert', (alert) => {
      console.log('Alert received:', alert);
      setAlerts(prev => [alert, ...prev.slice(0, 49)]); // Keep last 50 alerts
    });

    // Student mute status update
    newSocket.on('student-muted', ({ studentUserId, muted }) => {
      setRoomState(prev => ({
        ...prev,
        students: prev.students.map(student => 
          student.userId === studentUserId 
            ? { ...student, audioMuted: muted }
            : student
        )
      }));
    });

    setSocket(newSocket);

    // Setup heartbeat
    const heartbeatInterval = setInterval(() => {
      if (newSocket.connected) {
        newSocket.emit('heartbeat');
      }
    }, 30000);

    return () => {
      clearInterval(heartbeatInterval);
      newSocket.close();
    };
  }, [userId, role, roomId]);

  const sendFaceAlert = (direction, message) => {
    if (socket && role === 'student') {
      socket.emit('face-alert', {
        direction,
        message,
        timestamp: Date.now()
      });
    }
  };

  const muteStudent = (studentUserId, muted) => {
    if (socket && role === 'supervisor') {
      socket.emit('mute-student', {
        roomId,
        studentUserId,
        muted
      });
    }
  };

  const clearAlerts = () => {
    setAlerts([]);
  };

  const value = {
    socket,
    isConnected,
    roomState,
    alerts,
    sendFaceAlert,
    muteStudent,
    clearAlerts,
    userId,
    role,
    roomId
  };

  return (
    <SocketContext.Provider value={value}>
      {children}
    </SocketContext.Provider>
  );
};